import { SectionHeader } from "~/components/ui/SectionHeader";
import PlayStoreImage from "./Google-Play.jpg?jsx";
import AppleStoreImage from "./apple-store.jpg?jsx";

type StoreBadgeType = "playstore" | "appleStore";
type StoreBadgeInfo = {
  url: string;
  label: string;
};
const STORE_BADGE_DATA: Record<StoreBadgeType, StoreBadgeInfo> = {
  playstore: {
    url: "https://play.google.com/store/apps/details?id=it.ideasolutions.sgtv&hl=it",
    label: "Google Play Store",
  },
  appleStore: {
    url: "https://itunes.apple.com/it/app/superguidatv-3/id1024247665?mt=8",
    label: "App Store",
  },
};

export const SidebarStoreBadges = () => {
  return (
    <div class="sgtv-flex sgtv-flex-col sgtv-gap-7">
      <SectionHeader as="span" label="Scarica l'app" />
      <div class="sgtv-flex sgtv-flex-row sgtv-gap-4 md:sgtv-px-2">
        <div class="sgtv-flex sgtv-w-1/2 sgtv-items-center md:sgtv-w-auto">
          <a class="sgtv-block" href={STORE_BADGE_DATA["playstore"].url}>
            <PlayStoreImage
              class="sgtv-h-auto sgtv-w-full sgtv-max-w-32.5"
              alt={STORE_BADGE_DATA["playstore"].label}
            />
          </a>
        </div>
        <div class="sgtv-flex sgtv-w-1/2 sgtv-items-center md:sgtv-w-auto">
          <a class="sgtv-block" href={STORE_BADGE_DATA["appleStore"].url}>
            <AppleStoreImage
              class="sgtv-h-auto sgtv-w-full sgtv-max-w-32.5"
              alt={STORE_BADGE_DATA["appleStore"].label}
            />
          </a>
        </div>
      </div>
    </div>
  );
};
